module.exports = __webpack_public_path__ + "static/media/green-taxi.97bbd5be.png";